import { render, staticRenderFns } from "./tablePengelolaanK3L.vue?vue&type=template&id=4c1cf700&"
import script from "./tablePengelolaanK3L.vue?vue&type=script&lang=js&"
export * from "./tablePengelolaanK3L.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports